import axios from 'axios'
import { getBaseURLforBackEnd, getConfigAxios } from '@/utils.js'

export default {
    methods: {
        async doOrganismReportLab(pure, col, selected) {
            const config = getConfigAxios()
            config.responseType = 'blob'
            config.headers = { ...config.headers, Accept: 'application/pdf', Authorization: `Bearer ${this.access_token}` }
            try {
                const response = await axios.post(`${getBaseURLforBackEnd()}/api/lab_nonautomate_report_pdf_reportlab_v1`, {
                    ln: this.IDLABSelected.idlab, kind: 'organism',
                    img: { pure, col, data_want: selected }
                }, config)
                if (!response.data || !response.data.size || !response.data.type.includes('application/pdf')) {
                    throw new Error('ไม่ได้รับไฟล์ PDF จากเซิร์ฟเวอร์')
                }
                return response.data
            } catch (error) {
                let data = error.response && error.response.data
                if (data instanceof Blob) {
                    try {
                        const raw = await new Promise((resolve, reject) => {
                            const reader = new FileReader()
                            reader.onload = () => resolve(reader.result)
                            reader.onerror = reject
                            reader.readAsText(data)
                        })
                        data = JSON.parse(raw)
                    } catch (_) { data = null }
                }
                const message = data && (data.msg || data.message)
                const reference = data && data.request_id
                throw new Error((message || error.message || 'ไม่สามารถสร้าง PDF ได้') + (reference ? ` (รหัสอ้างอิง: ${reference})` : ''))
            }
        }
    }
}
